import { Icon } from 'components/Icon/IconDeprecated';

export const VIEW_MODES = ['list', 'grid'] as const;
export type ViewMode = (typeof VIEW_MODES)[number];

type ViewModeSwitchProps = {
  className?: string;
  value: ViewMode;
  onChange: (value: ViewMode) => void;
};

export function ViewModeSwitch({
  className,
  value,
  onChange,
}: ViewModeSwitchProps) {
  const options: { mode: ViewMode; label: string; icon: 'table' | 'grid' }[] = [
    { mode: 'list', label: 'List', icon: 'table' },
    { mode: 'grid', label: 'Grid', icon: 'grid' },
  ];

  const wrapClassName = [
    'inline-flex items-stretch overflow-hidden rounded-full border border-[hsl(var(--ui-border))] bg-[hsl(var(--ui-fg))]',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapClassName} role="group" aria-label="View mode">
      {options.map(({ mode, label, icon }, index) => (
        <button
          key={mode}
          className={[
            'appearance-none border-0 [--icon-spacing:0] inline-flex cursor-pointer items-center gap-1 px-[calc(var(--size-md)-2px)] py-[var(--size-xs)] text-[var(--text-md)] leading-none font-[var(--fw-display)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ui-borderHover))]',
            index > 0 ? 'border-l border-[hsl(var(--ui-border))]' : '',
            value === mode
              ? 'bg-[hsl(var(--ui-control-bgActive))] text-[hsl(var(--ui-text-highContrast))] shadow-[inset_0_0_0_1px_hsl(var(--ui-borderHover))]'
              : 'bg-[hsl(var(--ui-fg))] text-[hsl(var(--ui-text-lowContrast))] hover:bg-[hsl(var(--ui-control-bgHover))]',
          ].join(' ')}
          type="button"
          onClick={() => onChange(mode)}
          aria-pressed={value === mode}
        >
          <Icon name={icon} size="small" unstyled />
          <span>{label}</span>
        </button>
      ))}
    </div>
  );
}
